// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./examples/assets/slow.less
// module id = 37
// module chunks = 3 5